import {
  ChangeDetectorRef,
  DestroyRef,
  inject,
  Pipe,
  PipeTransform,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslationCoreService } from '@qtek/libs/translation-core';
import { Column } from '@qtek/shared/models';

@Pipe({ name: 'columnHeader', pure: false })
export class ColumnHeaderPipe implements PipeTransform {
  private readonly translateService = inject(TranslationCoreService);
  private _cdr: ChangeDetectorRef | null;

  private cache: Map<string, string> = new Map();

  // eslint-disable-next-line @angular-eslint/prefer-inject
  constructor(cdr: ChangeDetectorRef) {
    this._cdr = cdr;
    this.translateService.translationsOrLang$
      .pipe(takeUntilDestroyed(inject(DestroyRef)))
      .subscribe(() => {
        this.cache.clear();
        this._cdr.markForCheck();
      });
  }

  transform(column: Column): string {
    if (!column.label) {
      return column.description || '';
    }
    if (column.disableTranslate) {
      return column.label;
    }
    const key = column.label;
    const cached = this.cache.get(key);
    if (cached !== undefined) {
      return cached;
    }
    const value = this.translateService.instant(column.label);
    this.cache.set(key, value);
    return value;
  }
}
